export class EventRegistry {
    static register(type, eventConstructor) {
        EventRegistry.eventMap.set(type, eventConstructor);
    }
    static getEventClass(type) {
        const EventClass = EventRegistry.eventMap.get(type);
        if (!EventClass) {
            throw new Error(`No event class found for type: ${type}`);
        }
        return EventClass;
    }
    static hydrateEvent(params) {
        const EventClass = EventRegistry.getEventClass(params.type);
        if (!EventClass) {
            throw new Error(`Unknown event type: ${params.type}`);
        }
        return new EventClass(params.payload, params.metadata, {
            sortKey: params.sortKey,
            eventId: params.eventId,
        });
    }
}
EventRegistry.eventMap = new Map();
//# sourceMappingURL=event.registry.js.map